module.exports = __webpack_public_path__ + "static/img/xdj@2x.85f6a6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/xdj@2x.png
// module id = z7aX
// module chunks = 1